import React, { useState } from 'react';
import api from '../api/expoApi';

export default function OtpModal({ phone, purpose, onVerified, onCancel, autoRequest = true }) {
    const [step, setStep] = useState(autoRequest ? 'verify' : 'request');
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');
    const [err, setErr] = useState('');

    const requestOtp = async () => {
        setLoading(true); setErr(''); setMsg('');
        try {
            const r = await api.post('/otp/request', { phone, purpose });
            setMsg(r.data?.data?.message || 'OTP sent');
            setStep('verify');
        } catch (e) {
            setErr(e.response?.data?.message || 'Failed to send OTP');
        }
        setLoading(false);
    };

    const verifyOtp = async () => {
        if (code.length !== 6) { setErr('Enter the 6-digit code'); return; }
        setLoading(true); setErr(''); setMsg('');
        try {
            await api.post('/otp/verify', { phone, code, purpose });
            onVerified && onVerified({ phone, purpose });
        } catch (e) {
            setErr(e.response?.data?.message || 'Verification failed');
        }
        setLoading(false);
    };

    React.useEffect(() => {
        if (autoRequest && step === 'verify' && !msg) requestOtp();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="otp-modal-backdrop">
            <div className="otp-modal">
                <h3>Verify {purpose === 'COD_COLLECT' ? 'COD Collection' : purpose === 'DELIVERY' ? 'Delivery' : 'OTP'}</h3>
                <p>Phone: <strong>{phone}</strong></p>
                {step === 'request' && (
                    <button onClick={requestOtp} disabled={loading} className="primary">
                        {loading ? 'Sending...' : 'Send OTP'}
                    </button>
                )}
                {step === 'verify' && (
                    <>
                        {msg && <div className="info-msg">{msg}</div>}
                        <input
                            type="text"
                            maxLength="6"
                            value={code}
                            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                            placeholder="Enter 6-digit code"
                            inputMode="numeric"
                            autoFocus
                        />
                        <div className="actions">
                            <button onClick={requestOtp} disabled={loading} className="resend">
                                Resend
                            </button>
                            <button onClick={verifyOtp} disabled={loading || code.length !== 6} className="primary">
                                {loading ? 'Verifying...' : 'Verify'}
                            </button>
                        </div>
                    </>
                )}
                {err && <div className="err-msg">{err}</div>}
                <button className="cancel" onClick={onCancel}>Cancel</button>
                <style>{`
                    .otp-modal-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.5);
                                          display:flex; align-items:center; justify-content:center; z-index:2000; }
                    .otp-modal { background:#fff; border-radius:8px; padding:24px; width:90%; max-width:400px;
                                 box-shadow:0 8px 32px rgba(0,0,0,.3); }
                    .otp-modal h3 { margin-top:0; }
                    .otp-modal input { width:100%; font-size:2rem; text-align:center; padding:12px;
                                        letter-spacing:8px; border:2px solid #ddd; border-radius:6px; margin:12px 0; }
                    .actions { display:flex; gap:8px; }
                    .actions button { flex:1; padding:10px; border:none; border-radius:6px; cursor:pointer; font-size:1rem; }
                    .primary { background:#0d6efd; color:#fff; }
                    .resend { background:#f0f0f0; }
                    .cancel { width:100%; background:none; border:1px solid #ccc; padding:8px; border-radius:6px;
                              cursor:pointer; margin-top:12px; }
                    .info-msg { background:#d1e7dd; color:#0a3622; padding:8px; border-radius:4px; font-size:.9rem; }
                    .err-msg { background:#f8d7da; color:#842029; padding:8px; border-radius:4px;
                                margin-top:8px; font-size:.9rem; }
                `}</style>
            </div>
        </div>
    );
}
